import type { ChannelsTranslation } from './types';

export const channelsUr: ChannelsTranslation = {
  nav: 'چینلز',
  title: 'چینلز',
  description:
    'ای میل، واٹس ایپ اور ٹیلی گرام کا جواب اسی ان باکس سے دیں جس میں آپ کی ویب چیٹ آتی ہے۔',
  loading: 'چینلز لوڈ ہو رہے ہیں',
  guide: 'چینلز کیسے کام کرتے ہیں',
  brand: 'برانڈ',
  list: '{{brand}} کے چینلز',
  forbidden: {
    title: 'آپ چینلز کا انتظام نہیں کر سکتے',
    description:
      'ورک اسپیس کے مالک یا ایڈمن سے ایسا کردار مانگیں جس میں انٹیگریشنز سنبھالنے کی اجازت ہو۔',
  },
  noBrands: {
    title: 'ابھی کوئی برانڈ نہیں',
    description: 'پہلے ایک برانڈ شامل کریں۔ پھر اس کے چینلز یہاں جوڑیں۔',
    action: 'برانڈز اور انسٹال پر جائیں',
  },
  kind: {
    web: 'ویب چیٹ',
    email: 'ای میل',
    whatsapp: 'واٹس ایپ',
    telegram: 'ٹیلی گرام',
    other: 'دیگر',
  },
  status: {
    connected: 'جڑا ہوا',
    needs_attention: 'توجہ درکار ہے',
    paused: 'رکا ہوا',
  },
  problem: 'Chatwoot کا پیغام: {{problem}}',
  web: {
    text: 'آپ کی ویب سائٹ کا چیٹ ویجٹ۔',
    link: 'چیٹ ویجٹ کی ترتیبات',
  },
  conversations_one: 'اس ہفتے {{count}} گفتگو',
  conversations_other: 'اس ہفتے {{count}} گفتگوئیں',
  lastMessage: 'آخری پیغام: {{time}}',
  noMessages: 'ابھی کوئی پیغام نہیں',
  ai: {
    label: 'یہاں AI جواب دے',
    hint: 'بند: ہر گفتگو کا جواب آپ کی ٹیم دیتی ہے۔ چالو: پہلے AI جواب دیتا ہے اور ضرورت ہو تو گفتگو آپ کی ٹیم کو سونپ دیتا ہے۔',
    on: 'اب {{name}} پر پہلے AI جواب دیتا ہے۔',
    off: 'اب {{name}} پر ہر گفتگو کا جواب آپ کی ٹیم دیتی ہے۔',
  },
  team: {
    label: 'ٹیم',
    none: 'کوئی ٹیم نہیں (روٹنگ طے کرے)',
    hidden: 'ایسی ٹیم جو آپ کو نظر نہیں آتی',
    saved: '{{name}} پر نئی گفتگوئیں اب {{team}} کو جاتی ہیں۔',
    cleared: '{{name}} پر نئی گفتگوئیں کسے ملیں، یہ اب روٹنگ طے کرتی ہے۔',
  },
  pause: {
    action: 'روکیں',
    label: '{{name}} کو روکیں',
    title: 'کیا {{name}} کو روکنا ہے؟',
    body: 'جب تک آپ دوبارہ شروع نہ کریں، اس چینل کی نئی گفتگوئیں Chatwoot ہی میں رہیں گی۔ جو گفتگوئیں یہاں آ چکی ہیں وہ جاری رہیں گی۔',
    confirm: 'چینل روکیں',
    done: '{{name}} روک دیا گیا۔',
  },
  resume: {
    action: 'دوبارہ شروع کریں',
    label: '{{name}} دوبارہ شروع کریں',
    done: '{{name}} پھر سے چل رہا ہے۔',
  },
  unclaimed: {
    text: 'آپ کے Chatwoot اکاؤنٹ میں ملا۔',
    action: 'اس برانڈ کے لیے استعمال کریں',
    done: '{{name}} اب {{brand}} کی طرف سے جواب دیتا ہے۔',
  },
  empty: {
    title: 'ابھی کوئی ای میل، واٹس ایپ یا ٹیلی گرام چینل نہیں۔',
    description:
      'اپنا سپورٹ ای میل، واٹس ایپ بزنس نمبر یا ٹیلی گرام بوٹ یہیں جوڑیں۔ Chatwoot میں شامل کیے گئے چینلز «نئے چینلز تلاش کریں» سے یہاں نظر آتے ہیں۔',
  },
  check: {
    action: 'نئے چینلز تلاش کریں',
    busy: 'تلاش جاری ہے…',
    found_one: '{{count}} نیا چینل ملا',
    found_other: '{{count}} نئے چینلز ملے',
    none: 'کوئی نیا چینل نہیں ملا',
  },
  email: {
    connect: {
      action: 'ای میل جوڑیں',
      title: 'ای میل جوڑیں',
      step: 'مرحلہ {{step}} از {{total}}',
      steps: {
        address: 'آپ کا پتہ',
        imap: 'آنے والی میل (IMAP)',
        smtp: 'جانے والی میل (SMTP)',
        answering: 'جواب کون دے گا',
      },
      intros: {
        address: 'وہ پتہ جس پر آپ کے گاہک لکھتے ہیں۔',
        imap: 'Chatwoot نئی ای میلز اسی سرور سے پڑھتا ہے۔',
        smtp: 'آپ کے جوابات اسی پتے سے، اس سرور کے ذریعے بھیجے جاتے ہیں۔',
        answering: 'چنیں کہ یہاں ای میلز کا جواب کون دے گا۔ بعد میں اسے کارڈ پر بدل سکتے ہیں۔',
      },
      guide: 'ای میل کیسے جوڑیں',
      back: 'پیچھے',
      next: 'آگے',
      submit: 'جوڑیں',
      busy: 'آپ کا میل باکس جانچا جا رہا ہے…',
      busyHint:
        'جوڑنے سے پہلے Chatwoot آپ کے میل باکس میں سائن ان کر کے دیکھتا ہے۔ اس میں تھوڑا وقت لگ سکتا ہے۔',
      done: 'ای میل جڑ گئی۔ نئی ای میلز آپ کے ان باکس میں نظر آئیں گی۔',
    },
    fields: {
      address: 'سپورٹ پتہ',
      addressHint: 'مثلاً help@yourshop.com۔',
      name: 'Studio میں نام',
      nameDefault: 'سپورٹ ای میل',
      nameHint: 'یہ نام صرف آپ کی ٹیم کو نظر آتا ہے۔',
      provider: 'ای میل فراہم کنندہ',
      providerNone: 'اپنا فراہم کنندہ چنیں',
      custom: 'کوئی اور فراہم کنندہ',
      find: 'میری ترتیبات تلاش کریں',
      found: '{{provider}} کی ترتیبات بھر دی گئی ہیں۔',
      unknown:
        'ہمیں اس پتے کی ترتیبات معلوم نہیں۔ اپنے ای میل فراہم کنندہ سے اس کے IMAP اور SMTP سرور پوچھیں اور اگلے مراحل میں درج کریں۔',
      server: 'سرور',
      imapServer: 'آنے والی میل کا سرور',
      smtpServer: 'جانے والی میل کا سرور',
      port: 'پورٹ',
      imapPort: 'آنے والی میل کا پورٹ',
      smtpPort: 'جانے والی میل کا پورٹ',
      ssl: 'SSL استعمال کریں',
      sslHint: 'اسے چالو رکھیں، جب تک آپ کا فراہم کنندہ کچھ اور نہ کہے۔',
      login: 'لاگ اِن',
      imapLogin: 'آنے والی میل کا لاگ اِن',
      smtpLogin: 'جانے والی میل کا لاگ اِن',
      loginHint: 'عام طور پر آپ کا پورا ای میل پتہ۔',
      imapPassword: 'آنے والی میل کا پاس ورڈ',
      smtpPassword: 'جانے والی میل کا پاس ورڈ',
      security: 'حفاظت',
      securityNone: 'کوئی نہیں',
      noneHint:
        'حفاظت کے بغیر آپ کا پاس ورڈ غیر محفوظ طریقے سے بھیجا جاتا ہے۔ اسے تبھی چنیں جب آپ کا فراہم کنندہ کہے۔',
      sameLogin: 'آنے والی میل والا ہی لاگ اِن اور پاس ورڈ',
      show: '{{field}} دکھائیں',
      hide: '{{field}} چھپائیں',
    },
    appPassword: {
      title: 'ایپ پاس ورڈ استعمال کریں',
      text: 'آپ کا فراہم کنندہ آپ کے عام پاس ورڈ کی جگہ ایپ پاس ورڈ مانگتا ہے۔',
      link: 'ایپ پاس ورڈ بنائیں',
    },
    microsoft: {
      title: 'Microsoft کو Chatwoot میں جوڑیں',
      text: 'Microsoft اب ای میل ایپس کے لیے پاس ورڈ قبول نہیں کرتا۔ Outlook یا Microsoft 365 کو Chatwoot میں جوڑیں (Settings ← Inboxes ← Email ← Microsoft)، پھر "نئے چینلز تلاش کریں" استعمال کریں۔',
      blocked: 'پاس ورڈ کے ساتھ آگے بڑھنے کے لیے کوئی اور فراہم کنندہ چنیں۔',
    },
    errors: {
      name: 'ایک نام لکھیں، زیادہ سے زیادہ 100 حروف۔',
      address: 'ایک ای میل پتہ لکھیں، مثلاً help@yourshop.com۔',
      server: 'سرور کا نام لکھیں، مثلاً mail.yourshop.com۔',
      port: '1 سے 65535 تک کا پورٹ لکھیں۔',
      login: 'لاگ اِن لکھیں۔ یہ عام طور پر آپ کا ای میل پتہ ہوتا ہے۔',
      password: 'پاس ورڈ لکھیں۔',
      newPassword: 'نیا پاس ورڈ لکھیں، یا موجودہ پاس ورڈ ہی رکھیں۔',
    },
    settings: {
      action: 'ای میل کی ترتیبات',
      label: '{{name}} کی ای میل ترتیبات',
      title: 'ای میل کی ترتیبات',
      loading: 'ای میل کی ترتیبات لوڈ ہو رہی ہیں',
      general: 'پتہ',
      incoming: 'آنے والی میل (IMAP)',
      outgoing: 'جانے والی میل (SMTP)',
      change: 'پاس ورڈ بدلیں',
      changeLabel: '{{field}} بدلیں',
      keep: 'موجودہ پاس ورڈ رکھیں',
      kept: 'پاس ورڈ جیسا ہے ویسا ہی رہے گا۔',
      save: 'محفوظ کریں',
      busy: 'آپ کا میل باکس جانچا جا رہا ہے…',
      done: 'ای میل کی ترتیبات محفوظ ہو گئیں۔',
    },
    fix: {
      action: 'سائن اِن ٹھیک کریں',
      label: '{{name}} کا سائن اِن ٹھیک کریں',
      hint: 'Chatwoot اس میل باکس میں سائن اِن نہیں کر پا رہا۔ ایسا اکثر پاس ورڈ بدلنے کے بعد ہوتا ہے۔ نیا پاس ورڈ لکھیں۔',
    },
  },
  whatsapp: {
    connect: {
      action: 'واٹس ایپ جوڑیں',
      title: 'واٹس ایپ جوڑیں',
      steps: {
        number: 'آپ کا نمبر',
        answering: 'جواب کون دے گا',
        webhook: 'Meta کا ویب ہُک سیٹ کریں',
      },
      intros: {
        number: 'Meta کے Cloud API پر آپ کا واٹس ایپ بزنس نمبر۔',
        answering:
          'چنیں کہ یہاں واٹس ایپ پیغامات کا جواب کون دے گا۔ بعد میں اسے کارڈ پر بدل سکتے ہیں۔',
        webhook: 'آخری مرحلہ: Meta کو بتائیں کہ آپ کے گاہکوں کے پیغامات کہاں بھیجنے ہیں۔',
      },
      guide: 'واٹس ایپ کیسے جوڑیں',
      submit: 'جوڑیں',
      busy: 'Meta سے جانچ ہو رہی ہے…',
      busyHint:
        'نمبر جوڑنے سے پہلے Chatwoot آپ کا ایکسیس ٹوکن Meta سے جانچتا ہے۔ اس میں تھوڑا وقت لگ سکتا ہے۔',
      connected: 'آپ کا واٹس ایپ نمبر جڑ گیا۔ اب Meta کا ویب ہُک سیٹ کریں۔',
      done: 'واٹس ایپ جڑ گیا۔ Meta کا ویب ہُک سیٹ ہوتے ہی پیغامات آپ کے ان باکس میں آنے لگیں گے۔',
    },
    fields: {
      nameDefault: 'واٹس ایپ',
      phoneNumber: 'کاروباری فون نمبر',
      phoneNumberHint: '+ اور ملک کے کوڈ کے ساتھ، جیسے ‎+971 50 123 4567۔',
      phoneNumberId: 'فون نمبر آئی ڈی (Phone number ID)',
      businessAccountId: 'واٹس ایپ بزنس اکاؤنٹ آئی ڈی (WhatsApp Business Account ID)',
      accessToken: 'ایکسیس ٹوکن',
      accessTokenHint: 'یہ سیدھا Chatwoot کو جاتا ہے۔ Studio اسے نہیں رکھتا۔',
    },
    help: {
      title: 'یہ کہاں ملیں گے',
      text: 'یہ Meta کے WhatsApp Manager → API setup میں ملیں گے۔ کسی system user کا مستقل ایکسیس ٹوکن استعمال کریں۔',
      link: 'Meta کی Cloud API گائیڈ',
    },
    errors: {
      phoneNumber: 'نمبر + اور ملک کے کوڈ کے ساتھ لکھیں، جیسے ‎+971501234567۔',
      phoneNumberId: 'Phone number ID لکھیں۔ اس میں صرف ہندسے ہوتے ہیں۔',
      businessAccountId: 'WhatsApp Business Account ID لکھیں۔ اس میں صرف ہندسے ہوتے ہیں۔',
      accessToken: 'ایکسیس ٹوکن لکھیں۔ یہ کم از کم 20 حروف کا ہوتا ہے۔',
    },
    setup: {
      action: 'Meta سیٹ اپ',
      label: '{{name}} کا Meta سیٹ اپ',
      title: 'Meta کا ویب ہُک سیٹ کریں',
      loading: 'Meta سیٹ اپ لوڈ ہو رہا ہے',
      instructions:
        'Meta کے App Dashboard → WhatsApp → Configuration → Webhook میں یہ دونوں چسپاں کریں، Verify and save چنیں، پھر messages کو سبسکرائب کریں۔',
      callbackUrl: 'کال بیک URL (Callback URL)',
      verifyToken: 'ویریفائی ٹوکن (Verify token)',
      copy: 'کاپی کریں',
      copyLabel: '{{field}} کاپی کریں',
      noToken: 'Chatwoot نے ابھی Verify token نہیں بنایا۔ تھوڑی دیر بعد Meta سیٹ اپ دوبارہ کھولیں۔',
      done: 'ہو گیا',
    },
  },
  telegram: {
    connect: {
      action: 'ٹیلی گرام جوڑیں',
      title: 'ٹیلی گرام جوڑیں',
      intro:
        'اپنا ٹیلی گرام بوٹ جوڑیں۔ لوگ بوٹ کو جو پیغامات بھیجتے ہیں وہ آپ کے ان باکس میں آتے ہیں۔',
      guide: 'ٹیلی گرام کیسے جوڑیں',
      submit: 'جوڑیں',
      busy: 'ٹیلی گرام سے جانچ ہو رہی ہے…',
      done: 'ٹیلی گرام {{bot}} کے طور پر جڑ گیا۔ نئے پیغامات آپ کے ان باکس میں نظر آئیں گے۔',
      doneUnnamed: 'ٹیلی گرام جڑ گیا۔ نئے پیغامات آپ کے ان باکس میں نظر آئیں گے۔',
    },
    fields: {
      nameDefault: 'ٹیلی گرام',
      botToken: 'بوٹ ٹوکن',
      botTokenHint: 'یہ سیدھا Chatwoot کو جاتا ہے۔ Studio اسے نہیں رکھتا۔',
    },
    help: {
      title: 'بوٹ ٹوکن حاصل کریں',
      text: 'ٹیلی گرام پر ‎@BotFather کو پیغام بھیجیں، ‎/newbot بھیجیں اور جو ٹوکن وہ دے اسے کاپی کریں۔',
      link: 'BotFather کے بارے میں ٹیلی گرام کی گائیڈ',
    },
    errors: {
      botToken: '‎@BotFather سے ملا ٹوکن لکھیں۔ یہ ‎123456789:AAH…‎ جیسا ہوتا ہے، بغیر اسپیس کے۔',
    },
  },
  reply: {
    email: 'آپ کا جواب ای میل سے بھیجا جاتا ہے۔',
    whatsapp: 'آپ کا جواب واٹس ایپ پر بھیجا جاتا ہے۔',
    telegram: 'آپ کا جواب ٹیلی گرام پر بھیجا جاتا ہے۔',
    minutesLeft_one: 'آپ بس ایک منٹ اور جواب دے سکتے ہیں۔',
    minutesLeft_other: 'آپ مزید {{count}} منٹ تک جواب دے سکتے ہیں۔',
    closed:
      'واٹس ایپ اب صرف ٹیمپلیٹ پیغامات کی اجازت دیتا ہے۔ گاہک کے دوبارہ لکھنے کے بعد آپ پھر جواب دے سکتے ہیں۔',
  },
  templates: {
    button: 'ٹیمپلیٹ',
    open: 'ٹیمپلیٹ بھیجیں',
    title: 'واٹس ایپ ٹیمپلیٹ بھیجیں',
    description:
      'گاہک کے آخری پیغام کو 24 گھنٹے گزر جائیں تو واٹس ایپ صرف وہی ٹیمپلیٹ پہنچاتا ہے جنہیں Meta نے منظور کیا ہو۔',
    loading: 'ٹیمپلیٹ لوڈ ہو رہے ہیں',
    search: 'ٹیمپلیٹ تلاش کریں',
    category: {
      UTILITY: 'سروس',
      MARKETING: 'مارکیٹنگ',
      AUTHENTICATION: 'تصدیق',
      other: 'دیگر',
    },
    unsupported: {
      not_approved: 'Meta کی منظوری کا انتظار ہے',
      authentication: 'ایک بار والے کوڈ آپ کے اپنے سسٹم بھیجتے ہیں',
      media_header: 'تصویر، ویڈیو یا دستاویز والے ہیڈر کے ٹیمپلیٹ ابھی یہاں سے نہیں بھیجے جا سکتے',
    },
    synced: 'ٹیمپلیٹ آخری بار {{time}} اپ ڈیٹ ہوئے۔',
    syncHint: 'Chatwoot کے Meta سے سنک کرنے کے بعد نئے ٹیمپلیٹ یہاں نظر آتے ہیں۔',
    empty: {
      title: 'ابھی کوئی منظور شدہ ٹیمپلیٹ نہیں',
      description:
        'Meta کے WhatsApp Manager میں ایک ٹیمپلیٹ بنائیں۔ Meta کی منظوری اور Chatwoot کے سنک کرنے کے بعد وہ یہاں نظر آئے گا۔',
      guide: 'ٹیمپلیٹ پیغامات کیسے کام کرتے ہیں',
    },
    noMatch: '“{{query}}” سے کوئی ٹیمپلیٹ نہیں ملتا۔',
    back: 'تمام ٹیمپلیٹ',
    fields: {
      title: 'بھریں',
      none: 'اس ٹیمپلیٹ میں بھرنے کو کچھ نہیں۔',
      header: 'ہیڈر {{variable}}',
      body: 'پیغام {{variable}}',
      button: 'بٹن “{{label}}”',
      prefilled: 'اس گفتگو سے بھرا گیا۔',
      code: 'کوڈ، 15 حروف تک۔',
      url: 'بٹن کے لنک کے آخر میں جوڑا جاتا ہے۔',
    },
    preview: 'پیش نظارہ',
    send: 'ٹیمپلیٹ بھیجیں',
    missing_one: 'بھیجنے کے لیے ایک اور قدر بھریں۔',
    missing_other: 'بھیجنے کے لیے مزید {{count}} قدریں بھریں۔',
    errors: {
      required: 'یہ بھریں۔',
      code: 'کوڈ میں زیادہ سے زیادہ 15 حروف ہو سکتے ہیں۔',
    },
    sent: 'ٹیمپلیٹ بھیج دیا گیا۔',
  },
  chatwoot: {
    title: 'Chatwoot نے جواب نہیں دیا',
    description: 'تھوڑی دیر بعد دوبارہ کوشش کریں۔',
  },
};
